module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/assessment_achievements/2@2x_f4140068ff127bd01f14959dde561d7f.png";